import React from 'react';
import { useSelector } from 'react-redux';


const ColorSchemaPreviewPremiumPlusStore = () => {
  const {stylePalette = {}} = useSelector((state) => state.styles_palette);

  const colorsToPreview = {
    headerTopBgColor: stylePalette.header['theme_design/header/top_border_color'],
    headerBgColor: stylePalette.header['theme_design/header/header_bg_color'],
    headerColor: stylePalette.header['theme_design/header_primary/text_color'],
    buttonBgColor: stylePalette.buttons['theme_design/colors/button_bg_color'],
    buttonColor: stylePalette.buttons['theme_design/colors/button_color'],
    additionalHeaderBg: stylePalette.additional_header['theme_design/premium_plus_homepage/additional_header_bg'],
    additionalHeaderIcon: stylePalette.additional_header['theme_design/premium_plus_homepage/additional_header_icon_color'],
    additionalHeaderColor: stylePalette.additional_header['theme_design/premium_plus_homepage/additional_header_text_color'],
    menuColor: stylePalette.menu['theme_design/nav/color'],
    footerBgColor: stylePalette.footer['theme_design/footer/bg_color'],
    footerColor: stylePalette.footer['theme_design/footer/color'],
    footerBottomBgColor: stylePalette.footer['theme_design/footer_bottom/bg_color'],
    footerBottomColor: stylePalette.footer['theme_design/footer_bottom/color'],
    textColor: stylePalette.colors['theme_design/colors/color_primary_text_color'],
    productNameColor: stylePalette.category_page['theme_design/colors/product_name_color'],
    productPriceColor: stylePalette.category_page['theme_design/colors/price_color'],
  };

  const {
    headerTopBgColor,
    headerBgColor,
    headerColor,
    buttonBgColor,
    buttonColor,
    additionalHeaderBg,
    additionalHeaderIcon,
    additionalHeaderColor,
    menuColor,
    footerBgColor,
    footerColor,
    footerBottomBgColor,
    footerBottomColor,
    textColor,
    productNameColor,
    productPriceColor
  } = colorsToPreview;

  return (
    <div>
      <div className="min-h-8" style={{backgroundColor: `${headerTopBgColor}`}} />
      <div className="flex justify-between py-4" style={{backgroundColor: `${headerBgColor}`}}>
        <div className="uppercase px-5 text-24" style={{color: `${headerColor}`}}>logo</div>
        <div className="flex items-center justify-between w-full max-w-300 mb-5">
          <div className="min-w-60 min-h-4" style={{backgroundColor: `${menuColor}`}} />
          <div className="min-w-40 min-h-4" style={{backgroundColor: `${menuColor}`}} />
          <div className="min-w-40 min-h-4" style={{backgroundColor: `${menuColor}`}} />
          <div className="min-w-40 min-h-4" style={{backgroundColor: `${menuColor}`}} />
        </div>
        <div className="w-full flex justify-end items-center mb-5">
          <div className="max-h-4 min-h-4 mr-5 w-full max-w-100" style={{backgroundColor: `${headerColor}`}} />
        </div>
      </div>
      <div className="flex items-center justify-center px-2 py-4"  style={{backgroundColor: `${additionalHeaderBg}`}}>
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center justify-center w-full">
            <div
              className="min-h-8 max-w-8 w-full rounded"
              style={{border: `1px solid ${additionalHeaderIcon == 'inherit' ? headerColor : additionalHeaderIcon}`}}
            />
            <div
              className="min-h-4 w-full max-w-60 ml-2 mr-10"
              style={{backgroundColor: `${additionalHeaderColor == 'inherit' ? headerColor : additionalHeaderColor}`}}
            />
          </div>
          <div className="flex items-center justify-center w-full">
            <div
              className="min-h-8 max-w-8 w-full rounded"
              style={{border: `1px solid ${additionalHeaderIcon == 'inherit' ? headerColor : additionalHeaderIcon}`}}
            />
            <div
              className="min-h-4 w-full max-w-60 ml-2 mr-10"
              style={{backgroundColor: `${additionalHeaderColor == 'inherit' ? headerColor : additionalHeaderColor}`}}
            />
          </div>
          <div className="flex items-center justify-center w-full">
            <div
              className="min-h-8 max-w-8 w-full rounded"
              style={{border: `1px solid ${additionalHeaderIcon == 'inherit' ? headerColor : additionalHeaderIcon}`}}
            />
            <div
              className="min-h-4 w-full max-w-60 ml-2 mr-10"
              style={{backgroundColor: `${additionalHeaderColor == 'inherit' ? headerColor : additionalHeaderColor}`}}
            />
          </div>
          <div className="flex items-center justify-center w-full">
            <div
              className="min-h-8 max-w-8 w-full rounded"
              style={{border: `1px solid ${additionalHeaderIcon == 'inherit' ? headerColor : additionalHeaderIcon}`}}
            />
            <div
              className="min-h-4 w-full max-w-60 ml-2 mr-10"
              style={{backgroundColor: `${additionalHeaderColor == 'inherit' ? headerColor : additionalHeaderColor}`}}
            />
          </div>
        </div>
      </div>
      <div className="flex-column items-center justify-center max-w-360 w-full m-auto px-8 mt-8 mb-2">
        <div className="w-full min-h-12 max-w-80" style={{backgroundColor: `${textColor}`}} />
      </div>
      <div className="flex items-center justify-center flex-wrap mx-auto x-full max-w-80full">
        <div className="flex-column p-3 m-2 items-center" style={{boxShadow: '0px 0px 10px 1px #ccc', background: '#F1F0F0'}}>
          <div className="w-full min-w-60 min-h-60 mb-3 bg-white" />
          <div className="w-full max-w-60 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-80full min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-24 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productPriceColor}`}} />
          <div className="w-full max-w-100 flex justify-center border-radius-8 my-4" style={{backgroundColor: `${buttonBgColor}`}}>
            <div className="w-full min-h-4 max-w-40 mx-4 my-3" style={{backgroundColor: `${buttonColor}`}} />
          </div>
        </div>
        <div className="flex-column p-3 m-2 items-center" style={{boxShadow: '0px 0px 10px 1px #ccc', background: '#F1F0F0'}}>
          <div className="w-full min-w-60 min-h-60 mb-3 bg-white" />
          <div className="w-full max-w-60 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-80full min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-24 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productPriceColor}`}} />
          <div className="w-full max-w-100 flex justify-center border-radius-8 my-4" style={{backgroundColor: `${buttonBgColor}`}}>
            <div className="w-full min-h-4 max-w-40 mx-4 my-3" style={{backgroundColor: `${buttonColor}`}} />
          </div>
        </div>
        <div className="flex-column p-3 m-2 items-center" style={{boxShadow: '0px 0px 10px 1px #ccc', background: '#F1F0F0'}}>
          <div className="w-full min-w-60 min-h-60 mb-3 bg-white" />
          <div className="w-full max-w-60 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-80full min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-24 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productPriceColor}`}} />
          <div className="w-full max-w-100 flex justify-center border-radius-8 my-4" style={{backgroundColor: `${buttonBgColor}`}}>
            <div className="w-full min-h-4 max-w-40 mx-4 my-3" style={{backgroundColor: `${buttonColor}`}} />
          </div>
        </div>
        <div className="flex-column p-3 m-2 items-center" style={{boxShadow: '0px 0px 10px 1px #ccc', background: '#F1F0F0'}}>
          <div className="w-full min-w-60 min-h-60 mb-3 bg-white" />
          <div className="w-full max-w-60 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-80full min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-24 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productPriceColor}`}} />
          <div className="w-full max-w-100 flex justify-center border-radius-8 my-4" style={{backgroundColor: `${buttonBgColor}`}}>
            <div className="w-full min-h-4 max-w-40 mx-4 my-3" style={{backgroundColor: `${buttonColor}`}} />
          </div>
        </div>
      </div>
      <div className="w-full max-w-100 flex justify-center border-radius-8 my-2 mx-auto" style={{backgroundColor: `${buttonBgColor}`}}>
        <div className="w-full min-h-4 max-w-40 mx-4 my-3" style={{backgroundColor: `${buttonColor}`}} />
      </div>
      <div className="flex-column items-center justify-center max-w-360 w-full m-auto px-8 mt-8 mb-2">
        <div className="w-full min-h-12 max-w-80" style={{backgroundColor: `${textColor}`}} />
      </div>
      <div className="flex items-center justify-center flex-wrap mx-auto x-full max-w-80full">
        <div className="flex-column p-3 m-2 items-center" style={{boxShadow: '0px 0px 10px 1px #ccc', background: '#F1F0F0'}}>
          <div className="w-full min-w-60 min-h-60" />
        </div>
        <div className="flex-column p-3 m-2 items-center" style={{boxShadow: '0px 0px 10px 1px #ccc', background: '#F1F0F0'}}>
          <div className="w-full min-w-60 min-h-60" />
        </div>
        <div className="flex-column p-3 m-2 items-center" style={{boxShadow: '0px 0px 10px 1px #ccc', background: '#F1F0F0'}}>
          <div className="w-full min-w-60 min-h-60" />
        </div>
        <div className="flex-column p-3 m-2 items-center" style={{boxShadow: '0px 0px 10px 1px #ccc', background: '#F1F0F0'}}>
          <div className="w-full min-w-60 min-h-60" />
        </div>
      </div>
      <div className="w-full min-h-100 px-4 pt-8" style={{backgroundColor: `${footerBgColor}`}}>
        <div className="flex max-w-400 mx-auto">
          <div className="flex-column w-full max-w-100 mr-4">
            <div className="flex w-full mb-4">
              <div>
                <div className="w-12 h-12 mr-2 rounded" style={{backgroundColor: `${footerColor}`}} />
              </div>
              <div className="flex-column w-full max-w-80full">
                <div className="h-4 mb-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="h-4" style={{backgroundColor: `${footerColor}`}} />
              </div>
            </div>
          </div>
          <div className="flex-column w-full max-w-100 ml-4">
            <div className="flex-column w-full mb-4">
              <div className="flex w-full max-w-80full">
                <div className="h-8 w-32 mb-2 mr-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="h-8 w-8 mb-2 mr-2" style={{backgroundColor: `${footerColor}`}} />
              </div>
              <div className="flex">
                <div className="w-12 h-12 mr-2 rounded" style={{border: `1px solid ${footerColor}`}} />
                <div className="w-12 h-12 mr-2 rounded" style={{border: `1px solid ${footerColor}`}} />
                <div className="w-12 h-12 mr-2 rounded" style={{border: `1px solid ${footerColor}`}} />
              </div>
            </div>
          </div>
          <div className="flex-column w-full ml-4">
            <div className="flex-column w-full mb-4">
              <div>
                <div className="h-4 w-100 mb-2" style={{backgroundColor: `${footerColor}`}} />
              </div>
              <div className="flex w-full">
                <div className="h-16 w-full bg-white" style={{border: `1px solid ${footerColor}`}} />
                <div
                  className="w-full flex justify-center ml-1 max-w-40"
                  style={{backgroundColor: `${buttonBgColor}`, borderRadius: '0 8px 8px 0'}}
                >
                  <div className="w-full min-h-4 my-1 mx-3" style={{backgroundColor: `${buttonColor}`}} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full min-h-28 flex items-center justify-center" style={{backgroundColor: `${footerBottomBgColor}`}}>
        <div className="w-full max-w-200 min-h-4" style={{backgroundColor: `${footerBottomColor}`}} />
      </div>
    </div>
  );
};

export default ColorSchemaPreviewPremiumPlusStore;
